import {observer} from "mobx-react";
import React, {useEffect} from "react";
import "./styles/index.css";
import {smartPosStore} from "./SmartPosStore";
import LayoutSettings from "../../components/layout/LayoutSettings";
import Filter from "./components/Filter";
import Popup from "./components/Popup";
import Loading from "../../../../shared/components/loading/Loading";
import NoContent from "../../../../shared/components/NoContent";
import ReactPaginate from "react-paginate";
import {createSearchParams, useLocation, useNavigate} from "react-router-dom";
import {Dropdown} from "react-bootstrap";
import {vendorSmartPos} from "../../../../common/constants/Constants";
import {Switch} from "antd";
import {showDelete} from "../../../../shared/components/showDelete";

const SmartPos = () => {
    const navigate = useNavigate();
    const location = useLocation();
    useEffect(() => {
        const query = new URLSearchParams(window.location.search);
        smartPosStore.searchTemp = query.get("search")
            ? String(query.get("search"))
            : "";
        smartPosStore.staticParam.page_number = query.get("page")
            ? Number(query.get("page")) - 1
            : 0;
        smartPosStore.staticParam.status = query.get("status")
            ? String(query.get("status"))
            : "";
        smartPosStore.staticParam.vendor_name = query.get("vendor_name")
            ? String(query.get("vendor_name"))
            : "";

        smartPosStore.fetchListSmartPos(true).then()
    }, []);

    const handlePageClick = (data: { selected: number }) => {
        const selectedPage = data.selected;
        const params: any = {};
        if (smartPosStore.staticParam.search !== "")
            params.search = smartPosStore.staticParam.search;
        params.page = selectedPage + 1;
        navigate({
            search: createSearchParams(params).toString(),
        });
        smartPosStore.staticParam.page_number = selectedPage ;
        smartPosStore.fetchListSmartPos(true);
    };

    return (
        <>
            <LayoutSettings keyActive={"smart-pos"}>
                <div className="AdminPage">
                    <div className="AdminPage-header">
                        <h1 className="title">Danh sách máy Smart POS</h1>
                        <Filter/>
                    </div>
                    <div className="AdminPage-body">
                        <div className="table-container">
                            <div className="table-responsive">
                                <table className="table table-striped" id="table-2">
                                    <thead className="AdminPage-body__thead">
                                    <tr>
                                        <th
                                            style={{
                                                width: "15%",
                                                textAlign: "left",
                                            }}
                                        >
                                            Tên máy
                                        </th>
                                        <th
                                            style={{
                                                width: "25%",
                                                textAlign: "left",
                                            }}
                                        >
                                            POS ID
                                        </th>
                                        <th
                                            style={{
                                                width: "15%",
                                                textAlign: "left",
                                            }}
                                        >
                                            Nhà cung cấp
                                        </th>
                                        <th
                                            style={{
                                                width: "15%",
                                                textAlign: "left",
                                            }}
                                        >
                                            Ngày tạo
                                        </th>
                                        <th
                                            style={{
                                                width: "15%",
                                                textAlign: "left",
                                            }}
                                        >
                                            Trạng thái
                                        </th>
                                        <th
                                            style={{
                                                width: "15%",
                                                textAlign: "left",
                                            }}
                                        >
                                            Thao tác
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {smartPosStore.isLoading ? (
                                        <tr>
                                            <td colSpan={6} style={{textAlign: "center"}}>
                                                <Loading/>
                                            </td>
                                        </tr>
                                    ) : smartPosStore.dataListSmartPos.length <= 0 ? (
                                        <tr>
                                            <td colSpan={6}>
                                                {" "}
                                                <NoContent/>{" "}
                                            </td>
                                        </tr>
                                    ) : (
                                        smartPosStore.dataListSmartPos.length > 0 &&
                                        smartPosStore.dataListSmartPos.map((item: any, index: number) => (
                                            <tr key={item?.id}>
                                                <td>{item.pos_name}</td>
                                                <td>
                                                    {JSON.parse(item.data).pos_id}
                                                </td>
                                                <td>
                                                    {vendorSmartPos.find((itemVendor: any) => itemVendor.id === item.vendor_name)?.name}
                                                </td>
                                                <td>
                                                    {new Date(item.created_at).toLocaleDateString(
                                                        "en-GB"
                                                    )}
                                                </td>
                                                <td>
                                                    <Switch disabled={smartPosStore.isSave} size="default"
                                                            checked={item.status === 1 ? true : false}
                                                            onChange={(event) => {
                                                                smartPosStore.idSmartPos = item.id
                                                                smartPosStore.formDataSmartPos.pos_name = item.pos_name;
                                                                smartPosStore.formDataSmartPos.vendor_name = item.vendor_name;
                                                                smartPosStore.formDataSmartPos.data.pos_id = JSON.parse(item.data).pos_id;
                                                                smartPosStore.formDataSmartPos.data.secret_key = JSON.parse(item.data).secret_key;
                                                                smartPosStore.formDataSmartPos.data.merchant_id = JSON.parse(item.data).merchant_id;
                                                                smartPosStore.formDataSmartPos.status = item.status === 1 ? '0' : '1';
                                                                smartPosStore.updateStatusSmartPos();
                                                    }}/>
                                                </td>
                                                <td>
                                                    <Dropdown className="action-table">
                                                        <Dropdown.Toggle variant="success">
                                                            Thao tác
                                                        </Dropdown.Toggle>
                                                        <Dropdown.Menu>
                                                            <Dropdown.Item
                                                                onClick={() => {
                                                                    smartPosStore.openModal = true;
                                                                    smartPosStore.typeModal = "edit";
                                                                    smartPosStore.idSmartPos = item.id
                                                                    smartPosStore.formDataSmartPos = {
                                                                        pos_name: item.pos_name,
                                                                        vendor_name: item.vendor_name,
                                                                        status: `${item.status}`,
                                                                        data: {
                                                                            pos_id: JSON.parse(item.data).pos_id,
                                                                            secret_key: JSON.parse(item.data).secret_key,
                                                                            merchant_id: JSON.parse(item.data).merchant_id,
                                                                        }
                                                                    };
                                                                }}
                                                            >
                                                                <i className="fa fa-edit"></i>
                                                                Sửa
                                                            </Dropdown.Item>
                                                            <Dropdown.Item
                                                                onClick={() => {
                                                                    showDelete.showDeleteConfirm(
                                                                        "Xác nhận xoá Smart POS",
                                                                        "Bạn chắc chắn muốn xoá Smart POS này? Hành động này không thể hoàn tác",
                                                                        () =>
                                                                            smartPosStore.fetchDeleteRole(item?.id)
                                                                    );
                                                                }}
                                                            >
                                                                <i className="fa fa-trash"></i>
                                                                Xóa
                                                            </Dropdown.Item>
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                    </tbody>
                                </table>
                                {smartPosStore.isLoading
                                    ? ""
                                    : Math.ceil(
                                    smartPosStore.metadata.total_page
                                ) > 1 && (
                                    <ReactPaginate
                                        previousLabel={
                                            <img
                                                src="/assets/icon/fi-rr-angle-small-left.svg"
                                                alt="right"
                                            />
                                        }
                                        nextLabel={
                                            <img
                                                src="/assets/icon/fi-rr-angle-small-right.svg"
                                                alt="right"
                                            />
                                        }
                                        breakLabel={"..."}
                                        pageCount={Math.ceil(
                                            smartPosStore.metadata.total_page
                                        )}
                                        marginPagesDisplayed={2}
                                        pageRangeDisplayed={3}
                                        onPageChange={handlePageClick}
                                        containerClassName={"pagination"}
                                        activeClassName={"active"}
                                        forcePage={
                                            smartPosStore.staticParam.page_number
                                        }
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                    <Popup></Popup>
                </div>
            </LayoutSettings>
        </>
    )
}
export default observer(SmartPos)